export default function Scholarship() {
  return <div></div>;
}
